import React, { useState, useEffect } from "react";
import { UseBrand } from "../../../basic-information/brand/UseBrand";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { useNavigate, useLocation } from "react-router-dom";
import { UseMyPC } from "../../../hooks/UseMyPC";
import { rsGotoLast, rsProgress, rsActiveMenu } from "../../../RecoilStates";
import { useRecoilState } from "recoil";

export default function BrandSearchCom(props) {
  const { getBrandListGift } = UseBrand();
  const [brandRes, setBrandRes] = React.useState();
  const location = useLocation();
  const {
    myPc,
    goToLastPage,
    goToFirstPage,
    updatePage,
    updateSort,
    setScrollTo,
    refresh,
  } = UseMyPC("ID");
  const [search, setSearch] = useState("");
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [open, setOpen] = useState(false);
  const [selectedBrand, setSelectedBrand] = React.useState();

  useEffect(() => {
    if (
      myPc.page === 0 ||
      (location.state && location.state && location.state.isBack)
    ) {
      return;
    }

    if (search.length > 0) {
      setProgress(true);
      getBrandListGift(
        search,
        (brands) => {
          setOpen(true);
          setBrandRes(brands.brands);
        },
        false
      );
    } else {
      setBrandRes([]);
    }
  }, [myPc]);

  useEffect(() => {
    if (location.state && location.state) {
      location.state.isBack = false;
    }
    if (search.length > 0 && !location.state) {
      goToFirstPage();
    } else {
      refresh();
    }
  }, [search]);

  useEffect(() => {
    if (!props.selectedBrandID) {
      setSelectedBrand();
    }
  }, [props.selectedBrandID]);

  return brandRes ? (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Autocomplete
        id="combo-box-demo"
        options={brandRes ? brandRes : []}
        getOptionLabel={(brands) =>
          brands.faName ? brands.faName + " - " + brands.enName : ""
        }
        value={selectedBrand ? selectedBrand : ""}
        defaultValue={props.lvl1State.value ? props.lvl1State.value : ""}
        open={open}
        onClose={() => setOpen(false)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName + " - " + option.enName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedBrand(newValue);
            props.setName(newValue.faName);
            props.setter({
              ...props.lvl1State,
              value: newValue.id,
            });
            setBrandRes([]);
            setSearch("");
            setOpen(false);
          } else {
            setSelectedBrand();
            setSearch("");
            props.setter({
              ...props.lvl1State,
              value: 0,
            });
          }
        }}
        fullWidth
        size="small"
        renderInput={(params) => (
          <TextField
            onChange={(evt) => {
              setScrollTo(undefined);
              setSearch(evt.target.value);
            }}
            error={props.validation}
            {...params}
            placeholder="جستجو برند..."
          />
        )}
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getBrandListGift(
            "",
            (brands) => {
              setBrandRes(brands);
            },
            false
          );
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/brands" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
